import { AiFieldCellRequestCoordinator } from './ai-field-cell-request-coordinator';
import { waitForDatabaseStreamIdle } from './wait-for-database-stream-idle';

export const aiFieldCellRequestCoordinator = new AiFieldCellRequestCoordinator(
  waitForDatabaseStreamIdle
);
